import React, { useState } from "react";
import "./Dictionary.css";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos";

export default function Dictionary(props) {
  let [keyword, setKeyword] = useState(props.defaultKeyword);
  let [results, setResults] = useState(null);
  let [loaded, setLoaded] = useState(false);
  let [photos, setPhotos] = useState(null);
  let [error, setError] = useState(false);

  function handleImagesResponse(response) {
    setPhotos(response.data.photos);
  }

  function search() {
    let apiKey = `a1b23b3d4098a0a16ftb2b02cf94o4d8`;
    let apiUrl = `https://api.shecodes.io/dictionary/v1/define?word=${keyword}&key=${apiKey}`;
    axios.get(apiUrl).then(handleDictionaryResponse);

    let imagesApiKey = `a1b23b3d4098a0a16ftb2b02cf94o4d8`;
    let imagesApiUrl = `https://api.shecodes.io/images/v1/search?query=${keyword}&key=${imagesApiKey}`;
    axios.get(imagesApiUrl).then(handleImagesResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }
  function handleDictionaryResponse(response) {
    if (response.data.status === "not_found") {
      setError("Sorry, please try another word!");
    } else {
      setResults(response.data);
      setError(null);
    }
  }

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  function load() {
    setLoaded(true);
    search();
  }
  if (loaded) {
    return (
      <div className="Dictionary">
        <div className="inputSearcher">
          <form onSubmit={handleSubmit}>
            <input
              type="search"
              placeholder="e.g. wine, happy, overwhelm"
              onChange={handleKeywordChange}
            ></input>
          </form>
          <div className="hint">Type any word! </div>
        </div>

        <Results results={results} error={error} />
        <Photos photos={photos} />
      </div>
    );
  } else {
    load();
    return "Loading...";
  }
}
